<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Business Intelligence</h1>
      </div>
    </div>
  </div>
</header>
<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Business Intelligence para crecer con <span class="highlight-green">claridad</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Dashboards, reportes y análisis para transformar información en decisiones estratégicas.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Análisis avanzado de datos</li>
          <li><i class="bi bi-check-circle-fill"></i> Visualizaciones interactivas</li>
          <li><i class="bi bi-check-circle-fill"></i> Acceso seguro desde cualquier lugar</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-pie-chart"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-grid-3x3-gap"></i>
          </div>
          <h4 class="modern-service-card-title">Dashboards Interactivos</h4>
          <p>Visualiza KPIs en tiempo real con tableros diseñados para interpretación rápida.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-file-earmark-text"></i>
          </div>
          <h4 class="modern-service-card-title">Reporting Automatizado</h4>
          <p>Genera reportes claros y programados para mantener visibilidad constante del negocio.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-graph-up-arrow"></i>
          </div>
          <h4 class="modern-service-card-title">Análisis Predictivo</h4>
          <p>Anticipa tendencias y comportamientos futuros con modelos estadísticos avanzados.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Acceso seguro y flexible</li>
          <li><i class="bi bi-check-circle-fill"></i> Predicción de tendencias</li>
          <li><i class="bi bi-check-circle-fill"></i> Soporte dedicado y personalizado</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Transforma tus datos en decisiones inteligentes.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
